export default {
  VEHICLE_PART: "vehiclePart",
  VEHICLE: "vehicle",
};